<!-- 养护计划登记 -->
<template>
    <div class='page_content'>
        <maintenanceregisteActine ref="maintenanceregisteActine"></maintenanceregisteActine>
        <subComponents @selectDataAction="selectDataAction" ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
                @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform"
                    :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight"
                :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip
                    :min-width="tableValye.fieldWeight"
                    v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
                    :prop="tableValye.entityField" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <!-- <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span> -->
                        <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                        <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                        </span>
                        <!-- 状态判断 -->
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'cpmState'">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row.cpmState) }}</el-tag>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'auditState'">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row.auditState) }}</el-tag>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'isManual'">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row.isManual) }}</el-tag>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'cpmType'">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row.cpmType) }}</el-tag>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog title="全部合格" :visible.sync="regDia" width="400px" id="regDia">
            <el-form :model="reg" ref="reg" :rules="regRules">
                <el-form-item label="养护措施:" prop="cpdMeasuresArr">
                    <el-select multiple v-model="reg.cpdMeasuresArr" placeholder="请选择" :collapse-tags="true">
                        <el-option v-for="item in dictionariesData" :key="item.diValue" :label="item.diValue"
                            :value="item.diValue"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="regDia = false" size='mini'>取 消</el-button>
                <el-button type="primary" @click="confirmReg('reg')" size="mini">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel"
                :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import maintenanceregisteActine from "@/components/maintenanceregisteActine.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme,maintenanceregisteActine },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                bgmId: "",
                bgmName: "",
                page: 1,
                rows: 30,
                status: 0,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                type: 1
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            regDia: false,
            cpdMeasuresArr: [],
            reg: {
                cpdMeasures: '', //养护措施
                cpmId: '', //养护id
                cpdMeasuresArr: []
            },
            regRules: {
                cpdMeasuresArr: [{
                    required: true,
                    message: '请选择养护措施',
                    trigger: 'change'
                }],
            },
            dictionariesData: [],
            DialogVisible: false,
            seId: "",
            seTitle: "",
            seWidth: "",
            parentSearchData: {},
            sField: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.bgmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.bgmId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识ppamId
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [19],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result.yhcs;
                this.regDia = true
                console.log(this.dictionariesData);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        confirmReg(reg) {
            this.$refs[reg].validate((valid) => {
                if (valid) {
                    this.subYh()
                } else {
                    return false;
                }
            });
        },
        async subYh() {
            this.reg.cpdMeasures = this.reg.cpdMeasuresArr.toString()
            this.reg.cpmId = this.returnData.list[this.selectedDataIndex].cpmId
            let params = this.reg
            let responseData = await this.$http.batchMaintenance(
                params
            );
            if (responseData.status == 200) {
                this.regDia = false
                this.getDataList()
                return this.$message({
                    message: '操作成功',
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },

        
        selectDataAction(selectedData = {}, name, value) {
            switch (name) {
                case "bgmId":
                    this.getRequestData.bgmId = selectedData.bgmId;
                    this.getRequestData.bgmName = selectedData.bgmName;
                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.getButtonList();
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.formDataList = this.pageShowData.jurFormVoList
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取数据详情
        getDataDateils() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            dataInfo = JSON.parse(JSON.stringify(dataInfo));
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$refs["maintenanceregisteActine"].openBox(
                        1,
                        this.formDataList,
                        dataInfo
                    );
                    break;
                case 1:
                    this.getPartDictionariesData()
                    break

                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 提交审核
        submitDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("确定已经完成养护了吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.submitUnqualifiedDamage({
                        businessKey: dataInfo.lumId,
                    });
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getMaintenancePlanList(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

#regDia ::v-deep .el-input__inner {
    height: auto !important;
}
</style>